import * as _ from 'underscore';
import { Injectable } from '@angular/core';

@Injectable()
export class ModalService {
	private modals: any[] = [];

	add(modal: any): void {
		// add modal to array of active modals
		this.modals.push(modal);
	}

	remove(id: string): void {
		// remove modal from array of active modals
		const modalToRemove = _.findWhere(this.modals, { id });
		this.modals = _.without(this.modals, modalToRemove);
	}

	open(id: string): void {
		// open modal specified by id
		const modal = _.findWhere(this.modals, { id });
		modal.open();
	}

	close(id: string): void {
		// close modal specified by id
		const modal = _.find(this.modals, { id });
		modal.close();
	}
}
